<template>
    <div class="main">
        <HeaderComponent
            style="margin-top:100px;"
            :text="$t('text.edit_user')"
            backgroundColor="#fff"
        />
        <Transition appear name="fade">        
            
        </Transition>
            
        <Transition appear name="fade">
            <div class="body-container">
                
                <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                    <b-spinner
                        variant="dark"
                        label="Spinning"
                        class="login-loader"
                    ></b-spinner>
                </div>
                <b-form @submit="onSubmit" v-if="!loading">
                    <b-form-group id="input-group-1" :label="$t('text.first_name')" label-for="input-1">
                        <b-form-input
                        id="input-1"
                        v-model="user.first_name"
                        :placeholder="$t('text.enter_first_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" :label="$t('text.last_name')" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="user.last_name"
                        :placeholder="$t('text.enter_last_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-3" :label="$t('text.email_address')" label-for="input-3">
                        <b-form-input
                        id="input-3"
                        v-model="user.email"
                        type="email"
                        :placeholder="$t('text.enter_email')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-4" :label="$t('text.phone')" label-for="input-4">
                        <b-form-input
                        id="input-4"
                        v-model="user.phone"
                        type="number"
                        :placeholder="$t('text.enter_phone')"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-7" :label="$t('text.user_type')" label-for="input-5">
                        <b-form-select
                        id="input-7"
                        v-model="user.clearance"
                        :options="user_types"
                        required
                        ></b-form-select>
                    </b-form-group>
                    
                    <b-form-group id="input-group-5" :label="$t('text.password')" label-for="input-4">
                        <b-form-input
                        id="input-5"
                        v-model="form.password"
                        type="password"
                        :placeholder="$t('text.enter_password')"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-6" :label="$t('text.repeat_password')" label-for="input-4">
                        <b-form-input
                        id="input-6"
                        v-model="form.repeat_password"
                        type="password"
                        :placeholder="$t('text.repeat_password')"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="passwordValidation">
                            {{ $t('text.passwords_not_match') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.save') }}</b-button>
                    <b-button class="submit-button" @click="deleteUser()" variant="danger">{{ $t('text.delete') }}</b-button>
                </b-form>
            </div>
        </Transition>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import UserApiService from "../../services/user_api_service";
import User from "../../models/user";

export default {
    name: "UserEditPage",
    components: {
        HeaderComponent,
    },
    data() {
        return {
            loading: true,
            user: null,
            form: {
                password: '',
                repeat_password: ''
            },
            user_types: [
                { text: this.$t('text.standard'), value: 0 },
                { text: this.$t('text.family'), value: 1 },
                { text: this.$t('text.familyplus'), value: 2 },
                { text: this.$t('text.admin'), value: 3 }
            ]
        };
    },
    computed: {
        enableSubmitButton() {
            return true;
        },
        passwordValidation() {
            return (this.form.password == this.form.repeat_password) 
        }
    },
    methods: {
        async fetchUser() {
            this.loading = true;
            try {
                const data = await UserApiService.get_detail(this.$route.params.user_id);
                this.user = new User(data.data);
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async deleteUser() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_delete_user'), 
                {
                    okTitle: this.$t('text.delete_user'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'danger',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await UserApiService.delete(this.user.id);
                        this.loading = false;
                        this.$router.push("/admin/users")
                    } catch (error) {
                        this.loading = false;
                    }
                }
            })
        },
        async updateUser() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_update_user'), 
                {
                    okTitle: this.$t('text.save'),
                    cancelTitle: this.$t('text.cancel'),
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    this.user.email = this.user.email.replaceAll(" ", "")
                    var payload = this.user.toDict()
                    if (this.form.password != null && this.form.password != "") {
                        payload['password'] = this.form.password
                    }
                    try {
                        await UserApiService.patch(this.user.id, payload);
                        this.loading = false;
                        this.$router.push("/admin/users/")
                    } catch (error) {
                        var errorString = this.$t("text.something_went_wrong_try_later")
                        if (error.response.status === 400) {
                            errorString = ""
                            for (var key in error.response.data) {
                                errorString += error.response.data[key][0]
                                errorString += " "
                            }
                        }
                        this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                        this.loading = false;
                    }
                }
            })
        },
        onSubmit(event) {
            event.preventDefault()
            if (this.passwordValidation) {
                this.updateUser()
            }
        },
        makeToast(variant = null, title, body) {
            this.$bvToast.toast(body, {
                title: title,
                toaster: "b-toaster-top-center",
                variant: variant,
                solid: true
            });
        },
    },
    created() {
        this.fetchUser();
    },
    mounted() {
        if (!(this.$store.getters.token_valid && this.$store.getters.isLoggedIn)) {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute } });
        }
    }

};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.body-container {
    text-align: left;
    margin: auto;

    padding-bottom: 100px;
    padding-left: 30px;
    padding-right: 30px;

    max-width: 860px;
}

.submit-button {
    float:right;
}
</style>
